import * as dateFnsTzModule from "date-fns-tz";

type DateFnsFunction = (date: Date | string | number, timeZone: string) => Date;

interface DateFnsTzModuleType {
  toZonedTime?: DateFnsFunction;
  utcToZonedTime?: DateFnsFunction;
}

// Helper to handle version mismatch between packages (v3 vs v1/v2)
export const toZonedTime: DateFnsFunction = (date, timeZone) => {
  const dt = dateFnsTzModule as unknown as DateFnsTzModuleType;
  const fn = dt.toZonedTime || dt.utcToZonedTime;

  if (!fn) {
    throw new Error(
      "date-fns-tz: neither toZonedTime nor utcToZonedTime found"
    );
  }

  return fn(date, timeZone);
};
